// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pill-container .previousAndNextPage {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 24px 6px 30px;
}
.pill-container .previousAndNextPage a {
  display: flex;
  align-items: center;
}
.pill-container .previousAndNextPage .pill-disabled {
  text-decoration: none;
  cursor: no-drop;
}
.pill-container .text-container p {
  white-space: pre-line;
}
.pill-container .image-container {
  width: 100%;
  float: left;
  padding: 30px 0;
}
.pill-container .image-container img {
  width: 100%;
}
.pill-container .media-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  height: 210px;
  padding: 14px;
  margin: 24px 0;
  border-radius: 4.91px 24.54px 24.54px 24.54px;
  background-color: #fff;
  box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.05);
}
.pill-container .media-container iframe {
  width: 100%;
  height: 100%;
  border-radius: 4.91px 24.54px 24.54px 24.54px;
}
@media (max-width: 768px) {
  .pill-container__body-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding-top: 16px;
  }
  .pill-container__body-mobile .text-container {
    text-align: left;
  }
}
@media (min-width: 769px) {
  .pill-container .media-container {
    max-width: 50%;
    height: 380px;
    margin: 30px 30px 30px 0;
  }
  .pill-container .text-container {
    padding-top: 30px;
  }
  .pill-container .image-container {
    width: 50%;
    padding: 30px 30px 30px 0;
  }
}

.wrapper-pill-internal {
  padding: 14px 0 24px;
}
.wrapper-pill-internal .breadcrumb a {
  font-size: 13px;
  font-weight: 400;
  color: var(--sebrae-blue-6);
}
.wrapper-pill-internal .pill-header {
  margin-bottom: 32px;
  color: var(--sebrae-blue-6);
}
.wrapper-pill-internal .pill-header h1 {
  font-size: 24px;
  font-weight: 700;
  margin: 24px 0 16px;
  line-height: 1.2;
}
.wrapper-pill-internal .pill-header p {
  font-size: 13px;
}
.wrapper-pill-internal .content {
  color: var(--sebrae-gray);
}
.wrapper-pill-internal .content .text {
  font-size: 12px;
  line-height: 1.4;
  white-space: pre-line;
}
.wrapper-pill-internal .content .clear {
  clear: both;
}
.wrapper-pill-internal .content .media {
  margin: 16px 0;
  width: 100%;
}
.wrapper-pill-internal .content .media img {
  width: 100%;
  object-fit: cover;
}
.wrapper-pill-internal .content .media img,
.wrapper-pill-internal .content .media iframe {
  min-height: 51vw;
}
.wrapper-pill-internal .previousAndNextPage {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 24px 0 32px;
}
.wrapper-pill-internal .previousAndNextPage a {
  display: flex;
  align-items: center;
  text-decoration: none;
}
.wrapper-pill-internal .previousAndNextPage a p {
  font-size: 13px;
  font-weight: 400;
}
.wrapper-pill-internal .previousAndNextPage .pill-disabled {
  text-decoration: none;
  cursor: no-drop;
}
@media screen and (min-width: 768px) {
  .wrapper-pill-internal {
    padding-top: 0;
  }
  .wrapper-pill-internal .previousAndNextPage a p {
    padding-top: 0.7px;
    font-weight: 700;
  }
  .wrapper-pill-internal .pill-header {
    border-radius: 0 0 8px 8px;
    color: var(--sebrae-blue-6);
    padding-top: 16px;
  }
  .wrapper-pill-internal .pill-header .breadcrumb li {
    color: var(--sebrae-blue-6);
  }
  .wrapper-pill-internal .pill-header .breadcrumb svg {
    color: var(--sebrae-blue-6);
  }
  .wrapper-pill-internal .pill-header h1 {
    font-size: 27px;
  }
  .wrapper-pill-internal .content .text {
    font-size: 16px;
    font-weight: 400;
  }
  .wrapper-pill-internal .content .media {
    max-width: 465px;
  }
  .wrapper-pill-internal .content .media.video {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 277px;
    padding: 14px;
    margin: 24px 0;
    border-radius: 13.38px;
    background-color: #fff;
    box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.05);
  }
  .wrapper-pill-internal .content .media.video iframe {
    width: 100%;
    height: 100%;
    border-radius: 4.91px 24.54px 24.54px 24.54px;
  }
  .wrapper-pill-internal .content .media img,
  .wrapper-pill-internal .content .media iframe {
    height: 261px;
    min-height: auto;
  }
}
@media screen and (min-width: 1024px) {
  .wrapper-pill-internal .pill-header h1,
  .wrapper-pill-internal .pill-header p {
    padding-left: 104px;
  }
  .wrapper-pill-internal .content,
  .wrapper-pill-internal .previousAndNextPage {
    padding-left: 104px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/pill-content/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;AAAN;AAGI;EACE,qBAAA;EACA,eAAA;AADN;AAMI;EACE,qBAAA;AAJN;AAQE;EACE,WAAA;EACA,WAAA;EACA,eAAA;AANJ;AAQI;EACE,WAAA;AANN;AAUE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,6CAAA;EACA,sBAAA;EACA,6CAAA;AARJ;AAUI;EACE,WAAA;EACA,YAAA;EACA,6CAAA;AARN;AAYE;EACE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,iBAAA;EAVJ;EAYI;IACE,gBAAA;EAVN;AACF;AAaE;EACE;IACE,cAAA;IACA,aAAA;IACA,wBAAA;EAXJ;EAcE;IACE,iBAAA;EAZJ;EAeE;IACE,UAAA;IACA,yBAAA;EAbJ;AACF;;AAiBA;EACE,oBAAA;AAdF;AAiBI;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;AAfN;AAmBE;EACE,mBAAA;EACA,2BAAA;AAjBJ;AAmBI;EAEI,eAAA;EACA,gBAAA;EAEF,mBAAA;EACA,gBAAA;AAnBN;AAqBI;EACE,eAAA;AAnBN;AAsBE;EACE,yBAAA;AApBJ;AAsBI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AApBN;AAsBI;EACE,WAAA;AApBN;AAsBI;EACE,cAAA;EACA,WAAA;AApBN;AAsBM;EACE,WAAA;EACA,iBAAA;AApBR;AAuBM;;EAEE,gBAAA;AArBR;AA0BE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,oBAAA;AAxBJ;AA0BI;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAxBN;AA0BM;EACE,eAAA;EACA,gBAAA;AAxBR;AA4BI;EACE,qBAAA;EACA,eAAA;AA1BN;AA8BE;EA7EF;IA8EI,cAAA;EA3BF;EA+BM;IACE,kBAAA;IACA,gBAAA;EA7BR;EAkCE;IACE,0BAAA;IACA,2BAAA;IACA,iBAAA;EAhCJ;EAmCM;IACE,2BAAA;EAjCR;EAmCM;IACE,2BAAA;EAjCR;EAqCI;IACE,eAAA;EAnCN;EAuCI;IACE,eAAA;IACA,gBAAA;EArCN;EAuCI;IACE,gBAAA;EArCN;EAuCM;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,aAAA;IACA,aAAA;IACA,cAAA;IACA,sBAAA;IACA,sBAAA;IACA,6CAAA;EArCR;EAuCQ;IACE,WAAA;IACA,YAAA;IACA,6CAAA;EArCV;EAyCM;;IAEE,aAAA;IACA,gBAAA;EAvCR;AACF;AA4CE;EAKI;;IAEE,mBAAA;EA9CN;EAkDE;;IAEE,mBAAA;EAhDJ;AACF","sourcesContent":[".pill-container {\n  .previousAndNextPage {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    padding: 24px 6px 30px;\n\n    a {\n      display: flex;\n      align-items: center;\n    }\n\n    .pill-disabled {\n      text-decoration: none;\n      cursor: no-drop;\n    }\n  }\n\n  .text-container {\n    p {\n      white-space: pre-line;\n    }\n  }\n\n  .image-container {\n    width: 100%;\n    float: left;\n    padding: 30px 0;\n\n    img {\n      width: 100%;\n    }\n  }\n\n  .media-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 100%;\n    height: 210px;\n    padding: 14px;\n    margin: 24px 0;\n    border-radius: 4.91px 24.54px 24.54px 24.54px;\n    background-color: #fff;\n    box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.05);\n\n    iframe {\n      width: 100%;\n      height: 100%;\n      border-radius: 4.91px 24.54px 24.54px 24.54px;\n    }\n  }\n\n  @media (max-width: 768px) {\n    &__body-mobile {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 24px;\n      padding-top: 16px;\n\n      .text-container {\n        text-align: left;\n      }\n    }\n  }\n  @media (min-width: 769px) {\n    .media-container {\n      max-width: 50%;\n      height: 380px;\n      margin: 30px 30px 30px 0;\n    }\n\n    .text-container {\n      padding-top: 30px;\n    }\n\n    .image-container {\n      width: 50%;\n      padding: 30px 30px 30px 0;\n    }\n  }\n}\n\n.wrapper-pill-internal {\n  padding: 14px 0 24px;\n\n  .breadcrumb {\n    a {\n      font-size: 13px;\n      font-weight: 400;\n      color: var(--sebrae-blue-6);\n    }\n  }\n\n  .pill-header {\n    margin-bottom: 32px;\n    color: var(--sebrae-blue-6);\n\n    h1 {\n      font: {\n        size: 24px;\n        weight: 700;\n      }\n      margin: 24px 0 16px;\n      line-height: 1.2;\n    }\n    p {\n      font-size: 13px;\n    }\n  }\n  .content {\n    color: var(--sebrae-gray);\n\n    .text {\n      font-size: 12px;\n      line-height: 1.4;\n      white-space: pre-line;\n    }\n    .clear {\n      clear: both;\n    }\n    .media {\n      margin: 16px 0;\n      width: 100%;\n\n      img {\n        width: 100%;\n        object-fit: cover;\n      }\n\n      img,\n      iframe {\n        min-height: 51vw;\n      }\n    }\n  }\n\n  .previousAndNextPage {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    padding: 24px 0 32px;\n\n    a {\n      display: flex;\n      align-items: center;\n      text-decoration: none;\n\n      p {\n        font-size: 13px;\n        font-weight: 400;\n      }\n    }\n\n    .pill-disabled {\n      text-decoration: none;\n      cursor: no-drop;\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    padding-top: 0;\n\n    .previousAndNextPage {\n      a {\n        p {\n          padding-top: 0.7px;\n          font-weight: 700;\n        }\n      }\n    }\n\n    .pill-header {\n      border-radius: 0 0 8px 8px;\n      color: var(--sebrae-blue-6);\n      padding-top: 16px;\n\n      .breadcrumb {\n        li {\n          color: var(--sebrae-blue-6);\n        }\n        svg {\n          color: var(--sebrae-blue-6);\n        }\n      }\n\n      h1 {\n        font-size: 27px;\n      }\n    }\n    .content {\n      .text {\n        font-size: 16px;\n        font-weight: 400;\n      }\n      .media {\n        max-width: 465px;\n\n        &.video {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          height: 277px;\n          padding: 14px;\n          margin: 24px 0;\n          border-radius: 13.38px;\n          background-color: #fff;\n          box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.05);\n\n          iframe {\n            width: 100%;\n            height: 100%;\n            border-radius: 4.91px 24.54px 24.54px 24.54px;\n          }\n        }\n\n        img,\n        iframe {\n          height: 261px;\n          min-height: auto;\n        }\n      }\n    }\n  }\n\n  @media screen and (min-width: 1024px) {\n    // .breadcrumb-area {\n    //   margin: 0;\n    // }\n    .pill-header {\n      h1,\n      p {\n        padding-left: 104px;\n      }\n    }\n\n    .content,\n    .previousAndNextPage {\n      padding-left: 104px;\n    }\n  }\n\n  // @media screen and (min-width: 1280px) {\n  //   .breadcrumb-area {\n  //     margin: 0 -20px;\n  //   }\n  // }\n\n  // @media screen and (min-width: 1450px) {\n  //   .breadcrumb-area {\n  //     margin: 0 -104px;\n  //   }\n  // }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
